import React from "react";
import { Card, Row, Col, Typography } from "antd";

const { Text } = Typography;

const NPSDistributionChart = ({ data, promoters, detractors, nps, detractors_count, neutral_count, promoters_count, showNPS }) => {

    // Colorear columnas
    const getColumnStyle = (score) => {
        if (score >= 1 && score <= 6) {
            return { background: "#e53935", color: "#fff", borderRight: "2px solid #fff" };
        } else if (score === 7 || score === 8) {
            return { background: "#f1f1f1", color: "#000", borderRight: "2px solid #fff" };
        } else if (score === 9 || score === 10) {
            return { background: "#43a047", color: "#fff", borderRight: "2px solid #fff" };
        }
        return {};
    };

    return (
        <Card style={{ background: "transparent" }}>
            <div className="overflow-x-auto">
                <table
                    className="table-auto w-full text-center"
                    style={{
                        borderCollapse: "separate",
                        borderSpacing: 0,
                        width: "100%",
                        background: "transparent",
                    }}
                >
                    <thead>
                        <tr>
                            <th
                                style={{
                                    border: "1px solid #fff",
                                    padding: "4px",
                                    background: "#fff",
                                    width: "15px",
                                }}
                            >
                                {showNPS ? `Relación` : `Calificaciones`}
                            </th>
                            {Array.from({ length: 10 }, (_, i) => {
                                const score = i + 1;
                                return (
                                    <th
                                        key={score}
                                        style={{
                                            padding: "4px",
                                            width: "15px",
                                            ...getColumnStyle(score),
                                        }}
                                    >
                                        {score}
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {showNPS && data.map((row, idx) => (
                            <tr key={idx}>
                                <td
                                    style={{
                                        border: "1px solid #fff",
                                        padding: "4px",
                                        width: "15px",
                                    }}
                                >
                                    {row.label}
                                </td>
                                {Array.from({ length: 10 }, (_, i) => {
                                    const score = i + 1;
                                    const scoreData = row.scores.find((s) => s.score === score);
                                    const count = scoreData ? scoreData.count : 0;
                                    return (
                                        <td
                                            key={score}
                                            style={{
                                                padding: "4px",
                                                textAlign: "center",
                                                ...getColumnStyle(score),
                                            }}
                                        >
                                            {count > 0 ? count : ""}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}

                        {/* Fila de totales agrupada */}
                        <tr>
                            <td
                                style={{
                                    border: "1px solid #fff",
                                    padding: "4px",
                                    fontWeight: "bold",
                                    background: "#fff",
                                }}
                            >
                                TOTAL
                            </td>
                            {/* Detractores 1–6 */}
                            <td
                                colSpan={6}
                                style={{
                                    background: "#e53935",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    borderTop: "2px solid #fff",
                                    borderRight: "2px solid #fff",
                                    textAlign: "center",
                                }}
                            >
                                {detractors_count}
                            </td>
                            {/* Neutrales 7–8 */}
                            <td
                                colSpan={2}
                                style={{
                                    background: "#f1f1f1",
                                    color: "#000",
                                    fontWeight: "bold",
                                    borderTop: "2px solid #fff",
                                    borderRight: "2px solid #fff",
                                    textAlign: "center",
                                }}
                            >
                                {neutral_count}
                            </td>
                            {/* Promotores 9–10 */}
                            <td
                                colSpan={2}
                                style={{
                                    background: "#43a047",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    borderTop: "2px solid #fff",
                                    borderRight: "2px solid #fff",
                                    textAlign: "center",
                                }}
                            >
                                {promoters_count}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* KPIs */}
            <Row justify="center" gutter={24} style={{ marginTop: 24 }}>
                <Col style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                    <div style={{ fontSize: 14 }}>% Promotores</div>
                    <Card
                        style={{
                            background: "#43a047",
                            color: "#fff",
                            textAlign: "center",
                            width: 100,
                            height: 60,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Text strong style={{ fontSize: 18, color: "#fff" }}>
                            {promoters}
                        </Text>
                    </Card>
                </Col>
                <Col style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                    <div style={{ height: 20 }}></div>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 36, // tamaño grande
                        fontWeight: "bold",
                        height: 60,
                        textAlign: "center",
                    }}>
                        -
                    </div>
                </Col>
                <Col style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                    <div style={{ fontSize: 14 }}>% Detractores</div>
                    <Card
                        style={{
                            background: "#e53935",
                            color: "#fff",
                            textAlign: "center",
                            width: 100,
                            height: 60,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Text strong style={{ fontSize: 18, color: "#fff" }}>
                            {detractors}
                        </Text>
                    </Card>
                </Col>
                <Col style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                    <div style={{ height: 20 }}></div>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 36, // tamaño grande
                        fontWeight: "bold",
                        height: 60,
                        textAlign: "center",
                    }}>
                        =
                    </div>
                </Col>
                <Col style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                    <div style={{ fontSize: 14 }}>NPS</div>
                    <Card
                        style={{
                            background: "#009688",
                            color: "#fff",
                            textAlign: "center",
                            width: 100,
                            height: 60,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Text strong style={{ fontSize: 18, color: "#fff" }}>
                            {nps}
                        </Text>
                    </Card>
                </Col>
            </Row>
        </Card>
    );
};

export default NPSDistributionChart;
